import React, { type FC } from "react";
import { BusinessList } from "@src/components/business-list";
import { ListItem } from "@src/components/business-list";
import { BusinessLotValue, BusinessMeasureValue, BusinessStockObjValue } from "@src/components/business-data-display";
import { OverflowMarquee } from "@src/shared/ui";
import type { UseStockFullInventoryContentsQueryResult } from "../../hooks";
import {
    formatInventoryCells,
    isStockFullInventoryContentInventoried,
    isStockFullInventoryContentLotBased,
} from "../../helpers/formatStockFullInventoryContent";

/** Пропсы компонента {@link StockFullInventoryContentsList}. */
interface StockFullInventoryContentsListProps {
    /** Query-result строк АИ. */
    contentsQuery: UseStockFullInventoryContentsQueryResult;
    /**
     * Открывает форму инвентаризации строки АИ.
     * @param contentCode код строки АИ
     */
    onOpenContent: (contentCode: number) => void;
}

/** Список строк АИ для полной инвентаризации склада. */
export const StockFullInventoryContentsList: FC<StockFullInventoryContentsListProps> = ({
    contentsQuery,
    onOpenContent,
}) => {
    const { content, isFetching } = contentsQuery;

    return (
        <BusinessList isLoad={isFetching} emptyText="Список строк АИ пуст">
            {content.map((item) => {
                const isLotBased = isStockFullInventoryContentLotBased(item);
                const isInventoried = isLotBased && isStockFullInventoryContentInventoried(item);

                return (
                    <ListItem
                        key={item.Code}
                        disabled={!isLotBased}
                        tone={isInventoried ? "success" : "default"}
                        title={<BusinessStockObjValue stockObj={item.StockObj} mode="wrap" />}
                        props={[
                            {
                                label: "Факт. кол-во",
                                value: <BusinessMeasureValue value={item.FactReminder} measure={item.Measure} />,
                            },
                            {
                                label: "Партия",
                                value: <BusinessLotValue lot={item.Lot} fallback={isLotBased ? "—" : "Без партии"} />,
                            },
                            {
                                label: "Ячейки хранения",
                                value: <OverflowMarquee>{formatInventoryCells(item.PlacedCellRemainders)}</OverflowMarquee>,
                            },
                            {
                                label: "Партия инв-на",
                                value: isLotBased ? (isInventoried ? "Да" : "Нет") : "Недоступно",
                            },
                        ]}
                        onClick={
                            isLotBased
                                ? () => {
                                      onOpenContent(item.Code);
                                  }
                                : undefined
                        }
                    />
                );
            })}
        </BusinessList>
    );
};
